import React, {useContext, useEffect, useState} from 'react';
import {Button, Form, Input, Modal, Table, Tag} from 'antd';
import Colors from "../../../../styles/Colors";
import {BiCheck} from "react-icons/bi";
import Rebut from "../../../../model/multilleure/rebuts/Rebut";
import {AuthContext} from "../../../../config/AuthContext";
import {ColumnsType, TableProps} from "antd/es/table";
import Ingredient from "../../../../model/menudesign/Ingredient";
import PlantillaLista from "../../../PlantillaLista";
import {GetExtres} from "../../../../dao/multilleure/administracio/GetExtres";
import {PutRebutGrup} from "../../../../dao/multilleure/administracio/PutRebutGrup";

interface IngredientModalProps {
    visible: boolean;
    onClose: (value: boolean) => void;
}

const RebutGrupModal: React.FC<IngredientModalProps> = ({visible, onClose}) => {
    const [form] = Form.useForm();
    const [IBAN, setIBAN] = useState("");
    const [isRd, setIsRd] = useState<boolean>(false);
    const {isLoggedIn, userId, user, page} = useContext(AuthContext);

    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [activitatFiltres, setActivitatFiltres] = useState<{ text: string; value: string }[]>([]);
    const [casalFiltres, setCasalFiltres] = useState<{ text: string; value: string }[]>([]);
    const [descripcioFiltres, setDescripcioFiltres] = useState<{ text: string; value: string }[]>([]);
    const [selected, setSelected] = useState<Rebut[]>([]);
    const [coleccio, setDades] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    async function checkDades() {
        const dades = await GetExtres(page);
        setDades(dades);
        setFiltres(dades);
    }

    useEffect(() => {
        checkDades()
    }, [IBAN]);

    async function submit() {
        var formData = form.getFieldsValue();
        formData = {...formData, rows: selected};
        console.log("Form Data:", formData);

        await PutRebutGrup(formData, page);
        onClose(true);
    }


    const handleCancel = () => {
        onClose(false);
    };

    const tableProps: TableProps<any> = {
        loading
    };

    const onChange: TableProps<any>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };

    const expandedRowRender2 = (ele: Ingredient) => {
        return (
            <PlantillaLista element={ele}/>
        );
    };

    function setFiltres(elements: any[]) {
        const nomFiltresSet = new Set();
        const casalFiltresSet = new Set();
        const activitatFiltresSet = new Set();
        const descripcioFiltresSet = new Set();

        elements.forEach((element) => {
            nomFiltresSet.add(element.nom);
            casalFiltresSet.add(element.casal);
            activitatFiltresSet.add(element.activitat);
            descripcioFiltresSet.add(element.descripcio);
        });

        const nomFiltres = Array.from(nomFiltresSet).map((nom) => ({
            text: nom + "",
            value: nom + "",
        }));
        setNomFiltres(nomFiltres);

        const casalFiltres = Array.from(casalFiltresSet).map((casal) => ({
            text: casal + "",
            value: casal + "",
        }));
        setCasalFiltres(casalFiltres);

        const activitatFiltres = Array.from(activitatFiltresSet).map((activitat) => ({
            text: activitat + "",
            value: activitat + "",
        }));
        setActivitatFiltres(activitatFiltres);

        const descripcioFiltres = Array.from(descripcioFiltresSet).map((descripcio) => ({
            text: descripcio + "",
            value: descripcio + "",
        }));
        setDescripcioFiltres(descripcioFiltres);
    }

    const columns: ColumnsType<any> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
            sortOrder: 'descend',
            sorter: (a, b) => a.id - b.id,
        },
        {
            key: 'activitat',
            title: 'Activitat',
            dataIndex: 'activitat',
            width: 30,
            filterSearch: true,
            filters: activitatFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.activitat.startsWith(value) : false),
        },
        {
            key: 'casal',
            title: 'Casal',
            dataIndex: 'casal',
            width: 30,
            filterSearch: true,
            filters: casalFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.casal.startsWith(value) : false),
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            filterSearch: true,
            filters: nomFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.startsWith(value) : false),
        },
        {
            key: 'preu',
            title: 'Preu',
            dataIndex: 'preu',
            width: 30,
            render: (estat, ele) => (
                <Tag color={Colors.colors.color4}>{estat}&nbsp;&euro;</Tag>
            )
        },
        {
            key: 'descripcio',
            title: 'Descripcio',
            dataIndex: 'descripcio',
            width: 30,
            filterSearch: true,
            filters: descripcioFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.descripcio.startsWith(value) : false),
        }
    ];

    const rowSelection = {
        onChange: (selectedRowKeys: React.Key[], selectedRows: Rebut[]) => {
            setSelected(selectedRows);
        }
    };

    return (
        <Modal
            title="Editar Rebut"
            open={visible}
            footer={[]}
            width={1000}
            onCancel={handleCancel}
        >
            <Table
                {...tableProps}
                onChange={onChange}
                columns={columns}
                rowSelection={{
                    type: 'checkbox',
                    ...rowSelection,
                }}
                dataSource={coleccio}
            />
            <Form form={form} onFinish={submit}>
                <Form.Item label="Preu de cada rebut" name="preu" rules={[
                    { required: true, message: 'Camp obligatori.' },
                    {
                        validator: (_, value) =>
                            value && !isNaN(parseFloat(value)) && value.includes('.')
                                ? Promise.resolve()
                                : Promise.reject(new Error('El valor ha de ser decimal amb punt (.) y no coma (,)')),
                    },
                ]}>
                    <Input type={"decimal"} />
                </Form.Item>
                <Form.Item wrapperCol={{offset: 0, span: 16}}>
                    <Button title={"Aceptar"} htmlType={"submit"}
                            style={{backgroundColor: Colors.colors.color6}}><BiCheck/></Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default RebutGrupModal;
